import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { App } from "@/app/App";
import "@/index.css";

/**
 * The mock layer is imported dynamically behind a build-time constant.
 * `import.meta.env.VITE_USE_MOCKS` is replaced by a literal when Vite builds,
 * so in any build without the flag the branch is dead code and the whole
 * `@/mocks` tree (handlers, seed data, MSW) never reaches the bundle.
 * `.github/scripts/check-no-mocks-in-admin-bundle.sh` proves that in CI.
 */
async function boot() {
  if (import.meta.env.VITE_USE_MOCKS === "true") {
    // Must finish before the first render: a query fired during the first
    // paint would otherwise reach the network instead of a handler.
    const { startMocks } = await import("@/mocks/start");
    await startMocks();
  }

  createRoot(document.getElementById("root")!).render(
    <StrictMode>
      <App />
    </StrictMode>
  );
}

void boot();
